module.exports = __webpack_public_path__ + "static/media/latest-tools_icon.b687b3e3.jpg";